import { SettingsMenuGroup } from '@tempmee/react-blocks';
import { useOrganizationRows } from '../hooks/useOrganizationRows';

/** The Organization card of a multi-location account; no Figma yet, so it takes the Manage card's styling. */
export const OrganizationSection = () => {
  const rows = useOrganizationRows();

  return <SettingsMenuGroup heading="Organization" rows={rows} testID="location-organization" />;
};
